import { ModalAccordion } from "@/components/Accordion";
import { Accordion, Flex, Image, Text } from "@chakra-ui/react";

export function DataModal() {
  return (
    <>
      <Accordion defaultIndex={[0]}>
        <ModalAccordion title="ÍNDICE DE CARGA">
          <Text textStyle="Regular" alignItems="justify">
            O índice de carga de um pneu é um código numérico que corresponde à carga máxima de peso
            que um pneu pode suportar sob sua máxima pressão de calibragem. Para saber qual o índice
            adequado para o seu carro, basta que o código do novo pneu seja igual ou superior ao do
            pneu original.
          </Text>

          <Flex
            bgColor={"#FFCB05"}
            border="#ffc723 1px solid"
            borderRadius={"100px"}
            mt="1rem"
            direction={["column", "row"]}
            color={"white"}
            pl={"15px"}
          >
            <Image
              maxW="50px"
              src="https://cdn.pneufree.com.br/LINGLONG/images/Geral/atention.svg"
              alt="ALERT"
              m={["auto", "auto 15px"]}
            />
            <Text textStyle="Regular" m="1rem 1rem" fontSize={["1rem", "text1"]}>
              Jamais utilize um pneu cujo índice de carga seja inferior ao índice do pneu original
              do veículo. Calibragem abaixo do recomendado no manual do veículo resulta em perda de
              capacidade de carga.
            </Text>
          </Flex>
        </ModalAccordion>
        <ModalAccordion title="ÍNDICE DE VELOCIDADE">
          <Text textStyle="Regular" alignItems="justify">
            O índice de velocidade é um código alfabético que corresponde à velocidade máxima na
            qual um pneu pode rodar, com veículo carregado com carga máxima. Para saber qual o
            índice adequado para o seu carro, basta que o mesmo suporte uma velocidade igual ou
            superior ao do pneu original.
          </Text>

          <Flex border="#ffc723 1px solid " mt="1rem" direction={["column", "row"]}>
            <Image
              maxW="50px"
              maxH="50px"
              src="https://cdn.pneufree.com.br/CMS/images/Geral/01-29-2020-21-30alert.png"
              alt="ALERT"
              m={["auto", "auto 15px"]}
            />
            <Text textStyle="Regular" m="1rem 1rem" fontSize={["1rem", "text1"]}>
              Jamais utilize um pneu com índice de velocidade inferior ao do pneu original do
              veículo. Calibragem abaixo do recomendado no manual do veículo resulta em perda de
              capacidade de suportar altas velocidades bem como perda de estabilidade e
              dirigibilidade. Respeite sempre os limites de velocidade das ruas e estradas.
            </Text>
          </Flex>
        </ModalAccordion>
        <ModalAccordion
          title="TALAS COMPATÍVEIS
"
        >
          <Text textStyle="Regular">
            Se você está adquirindo pneus da medida original do carro e montando-os nas rodas
            originais, não precisa se preocupar com esse detalhe. Essas são as talas (larguras) de
            rodas mínima e máxima para essa medida de pneu, conforme o manual da ALAPA (Associação
            Latino Americana de Pneus e Aros), que é o manual técnico válido para todas as
            fabricantes de pneus e rodas. Tala é a medida, expressa em polegadas, da largura
            (bitola) da roda, iniciando-se do ponto de contato com o pneu (ou seja,
            desconsiderando-se a flange da roda)
          </Text>
          <Image
            m="15px auto"
            src="https://cdn.pneufree.com.br/LINGLONG/images/Site/img/tala.jpg"
            alt="Tala Pneu"
          />
        </ModalAccordion>
        <ModalAccordion
          title="TIPO DESENHO
"
        >
          <Text textStyle="Bold" color="black">
            SIMÉTRICO
          </Text>
          <Text textStyle="Regular">
            São pneus que podem ser montados sem que seja necessário observar sentido de rotação ou
            lado externo/interno. A maioria dos pneus é assim.
          </Text>
          <Text textStyle="Bold" mt="1rem" color="black">
            ASSIMÉTRICO
          </Text>
          <Text textStyle="Regular">
            São pneus que possuem lados interno e externo diferentes, combinando características de
            aderência, estabilidade e drenagem de modo mais elaborado que um pneu simétrico. Em uma
            das laterais está escrito "Lado externo" ou "Outside". Esse lado deve ser montado para
            fora, ou seja, do lado da face da roda.
          </Text>
        </ModalAccordion>
        <ModalAccordion
          title="TIPO
"
        >
          <Text textStyle="Bold">Sem Câmara (Tubeless, TL):</Text>
          <Text textStyle="Regular">
            Pneus que possuem um revestimento interno que dispensa o uso de câmara de ar. Todos os
            carros de passeio e camionetes atuais utilizam pneus sem câmara. A roda deve ser
            adequada a essa característica também. Neste caso usa-se uma válvula para pneus sem
            câmara, que se recomenda que seja trocada toda vez que se substitui o pneu velho por um
            novo.
          </Text>
        </ModalAccordion>
        <ModalAccordion title="CONSTRUÇÃO">
          <Text as="p" mt="1rem">
            <Text textStyle="Bold">Radial:</Text>
            <Text textStyle="Regular">
              Pneus radiais são os melhores e mais modernos. São mais eficientes em termos de
              consumo de combustível, resistência ao desgaste, estabilidade, conforto e resistência
              à perfuração. A estrutura segue o sentido do raio da circunferência do pneu (daí a
              designação "radial"), e na banda de rodagem são dotados de cintas de aço. São radiais
              99,9% dos pneus utilizados em automóveis de passeio e pick-ups, SUVs e vans. Sempre
              levam a letra "R" na medida, imediatamente antes do aro (exemplo: 175/70R13)
            </Text>
          </Text>
        </ModalAccordion>
      </Accordion>
    </>
  );
}
